"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPaginatedResponse = void 0;
const buildPaginatedResponse = (rows, total, limit, page) => {
    return {
        rows,
        pagination: {
            totalCount: total,
            totalPages: Math.ceil(total / limit),
            currentPage: page,
        },
    };
};
exports.buildPaginatedResponse = buildPaginatedResponse;
